module.exports = __webpack_public_path__ + "img/double-arrow-up.63c4993c.svg";